import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-[1920px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                九九视频
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              海量高清视频资源，无需注册即可免费观看。电影、电视剧、综艺、纪录片、动漫，每日更新，流畅播放零缓冲。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              视频分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">联系我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">服务条款</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              关注我们
            </h4>
            <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
              获取最新视频更新资讯，不错过任何精彩内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50 text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50 text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-background-50 text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-background-50 text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 九九免费视频 JiujiuFreeVideo.com 版权所有 | 仅供学习交流，请勿用于商业用途
          </p>
          <p className="text-xs text-foreground-500">
            <a href="#" className="hover:text-accent-400 transition-colors">隐私政策</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-accent-400 transition-colors">服务条款</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-accent-400 transition-colors">免责声明</a>
          </p>
        </div>
      </div>
    </footer>
  );
}